<div class="modal-title dialog-title"></div>
<div class="modal-body dialog-content" fuzzy-free>
   <pre id="OSLTxtDisplayArea">{{oslContent}}</pre>
</div>
<div class="modal-footer dialog-button-row">
   <button type="button" id="oslDialogCloseBtn" class="modal-button-base modal-button-right modal-button-blue" ngbAutofocus (click)="closeModal()">
      {{ 'CLOSE' | i18nv2 }}
   </button>
</div>